import ItemTypes from "../sections/tab_dnd/dnd_types";
import {DragSource} from "react-dnd";

const sectionSource = {
    beginDrag(props) {
        return {
            id: props.id,
            index: props.index,
        }
    },
};

export const pageSectionDragSource = DragSource(
    ItemTypes.PAGE_SECTION,
    sectionSource,
    (connect, monitor) => ({
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging(),
    })
);


// WEBPACK FOOTER //
// ./src/containers/templates/builder/dsdt/section_drag_source.js